import {
  CarrotAdBaseEntity,
  CarrotAdBaseEntityParams,
} from "@shared/services/event_tracking/entities";
import { CarrotTypes } from "@shared/services/event_tracking/carrot_tracking";
interface CarrotBannerAdEntityParams extends CarrotAdBaseEntityParams {
  interaction_id?: string;
  forward_url?: string;
  creative_type?: string;
  asset_type?: string;
}

export class CarrotBannerAdEntity extends CarrotAdBaseEntity {
  click_interaction_id?: string;
  forward_url?: string;
  creative_type?: string;
  asset_type?: string;

  constructor(params: CarrotBannerAdEntityParams) {
    super(params);
    this.type = CarrotTypes.Banner;
    this.entity_version = 3;
    this.click_interaction_id = params.interaction_id;
    this.forward_url = params.forward_url;
    this.creative_type = params.creative_type;
    this.asset_type = params.asset_type;
  }
}
